import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import CryptoJS from "crypto-js";
import { Box, HStack, Spinner, VStack, useMediaQuery } from "native-base";
import { getQuickLinkWalletAPI } from "../../../../api/apis/quicklinks";
import { Toaster } from "../../../../components/toaster";
import { useSelector } from "react-redux";
import AttachmentsCards from "../../../attachmentCards";
import NoDataFound from "../../../../components/noDataFound";
import { COLORS } from "../../../../utils/colors";
import CustomButton from "../../../../components/button";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import config from "../../../../utils/config";

const EventWalletListing = forwardRef((props, ref) => {
  const toaster = Toaster();
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [walletDetails, setWalletDetails] = useState([]);
  const eventsDetail = useSelector((state) => {
    return state.event.selectedEvent;
  });
  const [isLoading, setIsLoading] = useState(true);
  const [visibleItems, setVisibleItems] = useState(6);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const showMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 6);
  };

  useEffect(() => {
    getWalletListing();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getWalletListing = async () => {
    setIsLoading(true);
    let res = await getQuickLinkWalletAPI(userInfo.email, eventsDetail._id, "event");
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let wallet = [];
      res?.data?.data?.data?.map((item) => {
        if (item.boarding_pass && item.boarding_pass[0]) {
          item.boarding_pass.map((val) => {
            wallet.push({
              type: val.doc_type.split(".").pop(),
              file_name: val.file_name,
              document_name: val.doc_type,
              uploaded_time: val.uploaded_time,
              file_size: val.file_size,
              wallet_id: item._id,
              added_by: item.added_by,
            });
          });
        } else {
          wallet.push({
            type: item.documents[0].doc_type.split(".").pop(),
            file_name: item.documents[0].file_name,
            document_name: item.document_name,
            uploaded_time: item.documents[0].uploaded_time,
            file_size: item.documents[0].file_size,
            wallet_id: item._id,
            added_by: item.added_by,
          });
        }
      });
      setWalletDetails(wallet);
    }
    setIsLoading(false);
  };

  useImperativeHandle(ref, () => ({
    getWalletListing,
  }));

  return (
    <>
      {isLoading ? (
        <Box
          mt={5}
          mb={10}
          flex={1}
          alignItems="center"
          justifyContent="center"
        >
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <VStack>
          <div
            style={{
              display: MobileWindow ? "flex" : "grid",
              gridTemplateColumns:
                walletDetails.length > 0 &&
                `repeat(auto-fill, minmax(${80 / 3}%, 1fr))`,
              gap: "20px",
              marginRight: !MobileWindow && "20px",
              flexWrap: "wrap",
            }}
          >
            {walletDetails.length > 0 ? (
              <>
                {walletDetails?.slice(0, visibleItems).map((item) => (
                  <AttachmentsCards
                    key={item.id}
                    fileName={item?.document_name}
                    path={config.bucketPath + item.file_name}
                    timeline={item?.uploaded_time}
                    fileSize={item?.file_size}
                    scrollToTop={scrollToTop}
                    height="fit-content"
                    wallet
                    walletId={item.wallet_id}
                    onWalletDelete={getWalletListing}
                    addedBy={item.added_by}
                  />
                ))}
              </>
            ) : (
              <Box mb={"100px"} m={"auto"} top={25}>
                <NoDataFound dataName="document" image={false} />
              </Box>
            )}
          </div>
          {visibleItems < walletDetails.length && (
            <Box alignItems={"center"} my={5}>
              <CustomButton
                isOutline
                text="Read More"
                textColor={COLORS.BLACK_COLOR}
                bgColor={COLORS.BLACK_COLOR}
                borderRadius="50px"
                width="fit-content"
                py={3}
                onPress={showMore}
              />
            </Box>
          )}
        </VStack>
      )}
    </>
  );
});

export default EventWalletListing;
